import type { IconSvgProps } from "@modules/ui/components/huButtonIcon"

export const NoticeIcon: React.FC<IconSvgProps> = (props) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M5 8.26947C6.26578 8.46472 7.67778 8.78933 9 9.29861M5 12.2536C5.63949 12.3523 6.3163 12.4839 7 12.6557M12 6.07692L12 20.2696M3.99433 3.04687C6.21271 3.29655 9.19313 3.96825 11.3168 5.45049C11.725 5.73536 12.275 5.73536 12.6832 5.45049C14.8069 3.96825 17.7873 3.29655 20.0057 3.04687C21.1036 2.9233 22 3.83648 22 4.96316V16.1833C22 17.31 21.1036 18.2235 20.0057 18.3471C17.7873 18.5967 14.8069 19.2684 12.6832 20.7507C12.275 21.0355 11.725 21.0355 11.3168 20.7507C9.19313 19.2684 6.21271 18.5967 3.99433 18.3471C2.89642 18.2235 2 17.31 2 16.1833L2 4.96316C2 3.83648 2.89642 2.9233 3.99433 3.04687Z"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
)
